import type { NoiseReductionProvider } from "../../Stores/NoiseReductionStore";
import { PassThroughReducer } from "./PassThroughReducer";
import { BrowserReducer } from "./BrowserReducer";
import { RNNoiseWasmReducer } from "./RNNoiseWasmReducer";

export type { NoiseReductionProvider };

export interface NoiseReducer {
    /** Async init of the pipeline. Must be awaited before processStream(). */
    init(): Promise<void>;
    /**
     * Takes the raw input stream and returns a new MediaStream with processed
     * audio tracks. Video tracks from the input are forwarded untouched.
     */
    processStream(input: MediaStream): Promise<MediaStream>;
    /** Release all resources held by this reducer. */
    close(): void;
    /** The provider this instance was created for. */
    getProvider(): NoiseReductionProvider;
}

/**
 * Factory that creates the appropriate NoiseReducer for the given provider.
 * Falls back to BrowserReducer if RNNoise cannot be created.
 */
export function createNoiseReducer(provider: NoiseReductionProvider): NoiseReducer {
    switch (provider) {
        case "passthrough":
            return new PassThroughReducer();
        case "rnnoise":
            return new RNNoiseWasmReducer();
        case "browser":
        default:
            return new BrowserReducer();
    }
}
